/* ============================================================
   POST.JS — Page-specific scripts for post.html
   ============================================================ */

// ===== RELATED POSTS DATA =====
const relatedPosts = [
  { slug: "atlanta-to-manila", title: "Atlanta to Manila: The Real Places Behind Terminus Veil", category: "world-lore", date: "Mar 8, 2026", readTime: "6 min read", image: "/assets/world-tv.webp", excerpt: "Every Terminus Veil location is rooted in a real place." },
  { slug: "designing-fight-scenes", title: "How We Design a Fight Scene That Hits Different", category: "craft-process", date: "Mar 3, 2026", readTime: "8 min read", image: "/assets/cover-issue6.webp", excerpt: "It's not about the punches — it's about what's at stake." },
  { slug: "making-of-gldt-part-1", title: "Making of GLDT — Part 1: From Concept to Chaos", category: "behind-studio", date: "Mar 12, 2026", readTime: "7 min read", image: "/assets/world-gldt.webp", excerpt: "How a gangster horror comic was born from late-night sketches." }
];

const CATEGORY_LABELS = {
  'behind-studio': 'Behind the Studio',
  'world-lore': 'World & Lore',
  'releases': 'Releases',
  'culture-community': 'Culture & Community',
  'craft-process': 'Craft & Process'
};

// ===== RENDER RELATED POSTS =====
function renderRelatedPosts() {
  const grid = document.getElementById('related-posts-grid');
  grid.innerHTML = relatedPosts.map(post => `
    <article class="post-card">
      <a href="/blog/${post.slug}" class="post-card__link">
        <div class="post-card__image">
          <img src="${post.image}" alt="${post.title}" loading="lazy" />
        </div>
        <div class="post-card__body">
          <span class="cat-badge cat-badge--${post.category}">${CATEGORY_LABELS[post.category]}</span>
          <h3 class="post-card__title">${post.title}</h3>
          <p class="post-card__excerpt">${post.excerpt}</p>
          <div class="post-card__meta">
            <span class="post-card__date">${post.date}</span>
            <span class="post-card__sep">·</span>
            <span class="post-card__read-time">${post.readTime}</span>
          </div>
        </div>
      </a>
    </article>
  `).join('');
}

// ===== READING PROGRESS BAR =====
function initReadingProgress() {
  const bar = document.getElementById('reading-progress-bar');
  const postBody = document.getElementById('post-body');
  if (!bar || !postBody) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    bar.style.transition = 'none';
  }

  function updateProgress() {
    const rect = postBody.getBoundingClientRect();
    const postTop = rect.top + window.scrollY;
    const postBottom = rect.bottom + window.scrollY;
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;

    const progress = (scrollY - postTop + viewportHeight) / (postBottom - postTop);
    const clamped = Math.min(Math.max(progress, 0), 1);
    bar.style.width = (clamped * 100) + '%';
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();
}

// ===== TABLE OF CONTENTS =====
function initTOC() {
  const postBody = document.getElementById('post-body');
  const tocList = document.getElementById('toc-list');
  const tocNav = document.getElementById('post-toc');
  if (!postBody || !tocList) return;

  const headings = postBody.querySelectorAll('h2');

  // Hide TOC if fewer than 3 headings
  if (headings.length < 3) {
    if (tocNav) tocNav.style.display = 'none';
    return;
  }

  // Generate IDs and TOC items
  headings.forEach((heading, i) => {
    const id = 'section-' + (i + 1);
    heading.id = id;

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = heading.textContent;
    a.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    });
    li.appendChild(a);
    tocList.appendChild(li);
  });

  // Active section highlighting via IntersectionObserver
  const tocItems = tocList.querySelectorAll('li');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        tocItems.forEach(item => {
          const link = item.querySelector('a');
          if (link.getAttribute('href') === '#' + id) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      }
    });
  }, {
    rootMargin: '-' + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height')) + 24) + 'px 0px -70% 0px',
    threshold: 0
  });

  headings.forEach(h => observer.observe(h));

  // Collapse on mobile by default
  if (window.innerWidth <= 767) {
    const list = document.getElementById('toc-list');
    const toggle = document.getElementById('toc-toggle');
    list.classList.add('collapsed');
    toggle.textContent = '+';
    toggle.setAttribute('aria-expanded', 'false');
  }
}

// ===== TOC COLLAPSE/EXPAND =====
function initTOCToggle() {
  const toggle = document.getElementById('toc-toggle');
  const list = document.getElementById('toc-list');
  if (!toggle || !list) return;

  toggle.addEventListener('click', () => {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      list.classList.add('collapsed');
      toggle.textContent = '+';
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      list.classList.remove('collapsed');
      toggle.textContent = '−';
      toggle.setAttribute('aria-expanded', 'true');
    }
  });
}

// ===== COPY LINK =====
function initCopyLink() {
  const btn = document.getElementById('copy-link-btn');
  const text = document.getElementById('copy-link-text');
  if (!btn || !text) return;

  btn.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      text.textContent = '✓ Copied!';
      setTimeout(() => {
        text.textContent = 'Copy Link';
      }, 2000);
    } catch (err) {
      // Fallback
      const textarea = document.createElement('textarea');
      textarea.value = window.location.href;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      text.textContent = '✓ Copied!';
      setTimeout(() => {
        text.textContent = 'Copy Link';
      }, 2000);
    }
  });
}

// ===== INIT =====
(function init() {
  renderRelatedPosts();
  initReadingProgress();
  initTOC();
  initTOCToggle();
  initCopyLink();
})();
